// File: src/pages/AddProduct.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { IoIosAdd } from "react-icons/io";
import { FaUpload } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

import {
  AllCategoryList,
  CreateCategory,
  CreateSubCategory,
  CreateWarehousesave,
  SaveProduct,
  _Get,
  _GetByUrl,
  _BulkUpload,
} from "../import/ApiEndPoint/ApiCalling";

import {
  WareahouseList_For_addProduct,
  viewUnits,
  Bulk_Update_Product,
  Bulk_Upload_Product,
  ProductSection_List,
  Image_URL,
} from "../import/ApiEndPoint/Api";

const cssOnce = () => {
  if (document.getElementById("add-prod-inline-css")) return;
  const s = document.createElement("style");
  s.id = "add-prod-inline-css";
  s.textContent = `
    .ap-card{ border-radius:14px; border:1px solid #e5e7eb; }
    .ap-toolbar .count-pill{ background:#eef2ff; color:#3730a3; font-weight:700; padding:6px 10px; border-radius:999px; }
    .ap-chip{ display:inline-grid; place-items:center; width:26px; height:26px; border-radius:14px; cursor:pointer; background:#d1fae5; }
    .ap-inline-btn{ display:inline-flex; align-items:center; gap:6px; cursor:pointer; background:#e0f2fe; padding:2px 8px; border:1px solid #bae6fd; border-radius:12px; margin-left:6px; }
    .ap-small{ font-size:12px; color:#6b7280; }
    .ap-help{ color:#64748b; }
    .ap-img{ border-radius:10px; width:100%; height:110px; object-fit:cover; }
    .ap-del{ position:absolute; right:8px; top:4px; cursor:pointer; z-index:2; }
    .ap-fy-note{
      background:#fff7ed;
      color:#9a3412;
      border:1px solid #fed7aa;
      padding:8px 10px;
      border-radius:12px;
      font-size:12px;
      font-weight:700;
    }
  `;
  document.head.appendChild(s);
};

const toB = (v) => v === true || v === "true";

const num = (v) => (v === "" || v === null || v === undefined ? "" : Number(v));

const num0 = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const user = () => JSON.parse(localStorage.getItem("userData") || "{}");

const joinUrl = (...parts) => {
  const clean = parts.filter(Boolean).map((p, i) => {
    const str = String(p);
    if (i === 0) return str.replace(/\/+$/g, "");
    return str.replace(/^\/+/g, "").replace(/\/+$/g, "");
  });
  return clean.join("/");
};

/* ================= Financial Year Helpers ================= */

const normalizeFinancialYear = (value) => {
  const raw = String(value || "").trim();
  const match = raw.match(/^(\d{4})\s*-\s*(\d{2}|\d{4})$/);
  if (!match) return raw;

  const startYear = match[1];
  const endYear = match[2].length === 4 ? match[2].slice(-2) : match[2];

  return `${startYear}-${endYear}`;
};

const getFYStartYear = (date = new Date()) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth(); // Jan = 0
  return m >= 3 ? y : y - 1; // India FY starts April
};

const getFinancialYearLabel = (date = new Date()) => {
  const start = getFYStartYear(date);
  return normalizeFinancialYear(`${start}-${start + 1}`);
};

const buildFinancialYearOptions = (past = 5, future = 2) => {
  const currentStart = getFYStartYear(new Date());
  const arr = [];
  for (let y = currentStart - past; y <= currentStart + future; y++) {
    arr.push(normalizeFinancialYear(`${y}-${y + 1}`));
  }
  return arr.reverse();
};

export default function AddProduct() {
  const navigate = useNavigate();

  useEffect(() => cssOnce(), []);

  const currentFY = useMemo(() => getFinancialYearLabel(), []);
  const fyOptions = useMemo(() => buildFinancialYearOptions(5, 2), []);

  // ===== Data sources =====
  const [warehouses, setWarehouses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcats, setSubcats] = useState([]);
  const [units, setUnits] = useState([]);
  const [sections, setSections] = useState([]);

  // ===== Modals =====
  const [showWH, setShowWH] = useState(false);
  const [showCat, setShowCat] = useState(false);
  const [showSub, setShowSub] = useState(false);

  // ===== Bulk upload =====
  const [bulkMode, setBulkMode] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [bulkFile, setBulkFile] = useState(null);

  // ===== Forms =====
  const [imgFiles, setImgFiles] = useState([]);
  const [imgPrev, setImgPrev] = useState([]);

  const [creating, setCreating] = useState(false);
  const [errors, setErrors] = useState({});

  const [prod, setProd] = useState({
    financialYear: currentFY,
    warehouse: "",
    category: "",
    SubCategory: "",
    section: "",
    purchaseStatus: "",
    Product_Title: "",
    HSN_Code: "",
    GSTRate: "",
    MIN_stockalert: "",
    primaryUnit: "",
    secondaryUnit: "",
    secondarySize: "",
    Opening_Stock: "",
    openingRate: "",
    Purchase_Rate: "",
    status: "",
  });

  const [whForm, setWhForm] = useState({
    warehouseName: "",
    warehouseAddress: "",
    warehouseMobile: "",
    landlineNumber: "",
    status: "Active",
  });

  const [catForm, setCatForm] = useState({
    name: "",
    description: "",
    status: "Active",
  });

  const [subForm, setSubForm] = useState({
    categoryId: "",
    name: "",
    description: "",
    status: "Active",
  });

  // ===== Load initial lists =====
  useEffect(() => {
    const u = user();

    const init = async () => {
      try {
        const [whRes, catRes, unitRes] = await Promise.all([
          _Get(WareahouseList_For_addProduct, u?.database),
          AllCategoryList(u?._id, u?.database),
          _GetByUrl(viewUnits, u?.database),
        ]);

        setWarehouses(Array.isArray(whRes?.Warehouse) ? whRes.Warehouse : []);
        setCategories(Array.isArray(catRes?.Category) ? catRes.Category : []);
        setUnits(
          Array.isArray(unitRes?.dynamicUnit?.Units)
            ? unitRes.dynamicUnit.Units
            : [],
        );
      } catch (e) {
        console.error(e);
        setWarehouses([]);
        setCategories([]);
        setUnits([]);
      }

      try {
        const url = joinUrl(
          Image_URL,
          ProductSection_List,
          u?._id,
          u?.database,
        );

        const res = await fetch(url, {
          headers: { Accept: "application/json" },
        });

        if (!res.ok) throw new Error("HTTP " + res.status);

        const json = await res.json();
        const list = Array.isArray(json?.ProductSection)
          ? json.ProductSection
          : [];
        setSections(list);
      } catch (err) {
        console.error("Failed to load sections", err);
        setSections([]);
      }
    };

    init();
  }, []);

  // ===== Helpers =====
  const onProd = (name, value) => setProd((p) => ({ ...p, [name]: value }));

  const onCategorySelect = (value) => {
    onProd("category", value);
    const c = categories.find((x) => x?.name === value);
    setSubcats(Array.isArray(c?.subcategories) ? c.subcategories : []);
    onProd("SubCategory", "");
  };

  const handleUnitPick = (field, id) => {
    const u = units.find((x) => x?.unitId === id);
    onProd(field, u?.unitName || "");
  };

  const validate = () => {
    const e = {};

    if (!prod.financialYear) e.financialYear = "Select financial year";
    if (!prod.warehouse) e.warehouse = "Select a warehouse";
    if (!prod.category) e.category = "Select a category";
    if (!prod.Product_Title) e.Product_Title = "Enter product name";
    if (!prod.HSN_Code) e.HSN_Code = "Enter HSN";
    if (!prod.GSTRate) e.GSTRate = "Enter GST";
    if (!prod.MIN_stockalert) e.MIN_stockalert = "Enter min stock";
    if (!prod.primaryUnit) e.primaryUnit = "Select primary unit";
    if (prod.Opening_Stock === "") e.Opening_Stock = "Enter opening stock";
    if (prod.openingRate === "") e.openingRate = "Enter opening rate";
    if (!prod.Purchase_Rate) e.Purchase_Rate = "Enter purchase rate";
    if (!prod.status) e.status = "Select status";
    if (prod.secondaryUnit && !prod.secondarySize)
      e.secondarySize = "Enter secondary qty";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // ===== Images =====
  const addImages = (files) => {
    const fl = Array.from(files || []);
    if (!fl.length) return;

    const next = [...imgFiles, ...fl];

    const readers = fl.map(
      (f) =>
        new Promise((res) => {
          const r = new FileReader();
          r.onload = (ev) => res(ev.target.result);
          r.readAsDataURL(f);
        }),
    );

    Promise.all(readers).then((previews) => {
      setImgFiles(next);
      setImgPrev((p) => [...p, ...previews]);
    });
  };

  const removeImage = (idx) => {
    setImgFiles((p) => p.filter((_, i) => i !== idx));
    setImgPrev((p) => p.filter((_, i) => i !== idx));
  };

  // ===== Submit Bulk =====
  const onBulkSubmit = async (e) => {
    e.preventDefault();

    if (!uploadType) return swal("Choose type of upload");
    if (!bulkFile) return swal("Select a file");

    const u = user();
    const fd = new FormData();

    fd.append("file", bulkFile);
    fd.append("database", u?.database || "");
    fd.append(
      "openingFinancialYear",
      normalizeFinancialYear(prod.financialYear || currentFY),
    );

    try {
      const url =
        uploadType === "Update"
          ? `${Bulk_Update_Product}/${u?.database}`
          : `${Bulk_Upload_Product}/${u?.database}`;

      await _BulkUpload(url, fd);

      swal(
        "Success",
        uploadType === "Update" ? "Product updated" : "Product added",
        "success",
      );

      navigate("/app/freshlist/house/houseProductList");
    } catch (err) {
      console.error(err);
      swal("Error", "Something went wrong during bulk upload", "error");
    }
  };

  // ===== Submit Single =====
  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setCreating(true);

    const u = user();
    const fd = new FormData();

    const openingQty = num0(prod.Opening_Stock);
    const openingRate = num0(prod.openingRate);
    const fy = normalizeFinancialYear(prod.financialYear || currentFY);

    const payload = {
      id: (prod.Product_Title || "").replace(/\s/g, ""),
      database: u?.database,

      // ✅ Only opening financial year is saved separately
      openingFinancialYear: fy,

      category: prod.category,
      SubCategory: prod.SubCategory,

      // ✅ Product Section ID
      productSection: prod.section || "",

      warehouse: prod.warehouse,
      Product_Title: (prod.Product_Title || "").toUpperCase(),
      price: num(prod.Purchase_Rate),
      Product_MRP: num(prod.Purchase_Rate),
      igstType: toB(prod.purchaseStatus),
      Size: num(prod.secondarySize) || "",
      HSN_Code: prod.HSN_Code,
      GSTRate: num(prod.GSTRate),
      gstPercentage: num(prod.GSTRate),
      primaryUnit: prod.primaryUnit,
      secondaryUnit: prod.secondaryUnit,
      secondarySize: num(prod.secondarySize) || "",

      // ✅ Old fields kept for existing backend compatibility
      Opening_Stock: openingQty,
      openingRate,
      Purchase_Rate: num(prod.Purchase_Rate),
      landedCost: num(prod.Purchase_Rate),
      MIN_stockalert: num(prod.MIN_stockalert),
      status: prod.status,
    };

    fd.append("created_by", u?._id || "");

    Object.entries(payload).forEach(([k, v]) => fd.append(k, v));

    imgFiles.forEach((f) => fd.append("files", f));

    try {
      const res = await SaveProduct(fd);

      if (res?.status) {
        swal("Success", "Product Created Successfully", "success");
        navigate(-1);
      } else {
        swal("Error", res?.message || "Failed to create product", "error");
      }
    } catch (err) {
      console.error(err);
      swal("Error", "Something went wrong", "error");
    } finally {
      setCreating(false);
    }
  };

  // ===== Create Warehouse =====
  const onCreateWH = async (e) => {
    e.preventDefault();

    const u = user();

    try {
      await CreateWarehousesave({
        warehouseName: whForm.warehouseName,
        mobileNo: whForm.warehouseMobile,
        address: whForm.warehouseAddress,
        landlineNumber: whForm.landlineNumber,
        database: u?.database,
        status: whForm.status,
      });

      swal("Warehouse saved");

      const res = await _Get(WareahouseList_For_addProduct, u?.database);
      setWarehouses(Array.isArray(res?.Warehouse) ? res.Warehouse : []);

      setShowWH(false);
      setWhForm({
        warehouseName: "",
        warehouseAddress: "",
        warehouseMobile: "",
        landlineNumber: "",
        status: "Active",
      });
    } catch (err) {
      console.error(err);
      swal("Error", "Unable to save warehouse", "error");
    }
  };

  // ===== Create Category =====
  const onCreateCat = async (e) => {
    e.preventDefault();

    const u = user();
    const fd = new FormData();

    fd.append("created_by", u?._id || "");
    fd.append("name", catForm.name);
    fd.append("description", catForm.description);
    fd.append("status", catForm.status);

    try {
      await CreateCategory(fd);

      swal("Success", "Category Created", "success");

      const res = await AllCategoryList(u?._id, u?.database);
      setCategories(Array.isArray(res?.Category) ? res.Category : []);

      setShowCat(false);
      setCatForm({ name: "", description: "", status: "Active" });
    } catch (err) {
      console.error(err);
      swal("Error", "Could not create category", "error");
    }
  };

  // ===== Create Subcategory =====
  const onCreateSub = async (e) => {
    e.preventDefault();

    const u = user();
    const fd = new FormData();

    fd.append("created_by", u?._id || "");
    fd.append("name", (subForm.name || "").toUpperCase());
    fd.append("category", subForm.categoryId);
    fd.append("description", subForm.description || "");
    fd.append("status", subForm.status || "Active");

    try {
      await CreateSubCategory(fd);

      swal("Success", "Subcategory Created", "success");

      const res = await AllCategoryList(u?._id, u?.database);
      const list = Array.isArray(res?.Category) ? res.Category : [];

      setCategories(list);

      const selectedCat = list.find(
        (x) => String(x?._id) === String(subForm.categoryId),
      );

      if (selectedCat?.name === prod.category) {
        setSubcats(
          Array.isArray(selectedCat?.subcategories)
            ? selectedCat.subcategories
            : [],
        );
      }

      setShowSub(false);
      setSubForm({
        categoryId: "",
        name: "",
        description: "",
        status: "Active",
      });
    } catch (err) {
      console.error(err);
      swal("Error", "Could not create subcategory", "error");
    }
  };

  // ===== Count =====
  const countInfo = useMemo(() => {
    const req = [
      prod.financialYear,
      prod.warehouse,
      prod.category,
      prod.Product_Title,
      prod.HSN_Code,
      prod.GSTRate,
      prod.MIN_stockalert,
      prod.primaryUnit,
      prod.Opening_Stock !== "" ? "ok" : "",
      prod.openingRate !== "" ? "ok" : "",
      prod.Purchase_Rate,
      prod.status,
    ];

    const done = req.filter(Boolean).length;
    return `${done}/${req.length} required`;
  }, [prod]);

  const sectionOptions = [
    { _id: "RAW_MATERIAL", name: "RAW PRODUCTS" },
    ...sections,
  ];

  return (
    <>
      {/* Toolbar */}
      <Row className="ap-toolbar" style={{ marginBottom: 10 }}>
        <Col sm="12">
          <Card
            className="ap-card"
            style={{ padding: 8, background: "#f4f7f6" }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  textTransform: "uppercase",
                  fontSize: 18,
                }}
              >
                Create Product <span className="count-pill">{countInfo}</span>
              </div>

              <div style={{ flex: "1 1 240px" }} />

              {!bulkMode ? (
                <Button
                  style={{
                    backgroundColor: "rgb(8, 91, 245)",
                    color: "#fff",
                    fontWeight: 700,
                    height: 32,
                  }}
                  onClick={() => setBulkMode(true)}
                >
                  Bulk Upload
                </Button>
              ) : (
                <Button
                  color="secondary"
                  outline
                  style={{ height: 32 }}
                  onClick={() => setBulkMode(false)}
                >
                  Back to Single Create
                </Button>
              )}

              <Button
                outline
                color="secondary"
                style={{ height: 32 }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Bulk Upload */}
      {bulkMode ? (
        <Row>
          <Col sm="12">
            <Card className="ap-card">
              <CardBody>
                <Form onSubmit={onBulkSubmit}>
                  <Row>
                    <Col lg="3" md="6" sm="12">
                      <FormGroup>
                        <Label>Financial Year *</Label>
                        <Input
                          type="select"
                          value={prod.financialYear}
                          onChange={(e) =>
                            onProd("financialYear", e.target.value)
                          }
                        >
                          {fyOptions.map((fy) => (
                            <option key={fy} value={fy}>
                              {fy}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <Label>Type of Upload *</Label>
                      <div className="d-flex align-items-center gap-3">
                        <label className="m-0 d-flex align-items-center gap-1">
                          <Input
                            type="radio"
                            name="uploadType"
                            checked={uploadType === "New Upload"}
                            onChange={() => setUploadType("New Upload")}
                          />
                          <span>New Upload</span>
                        </label>

                        <label className="m-0 d-flex align-items-center gap-1">
                          <Input
                            type="radio"
                            name="uploadType"
                            checked={uploadType === "Update"}
                            onChange={() => setUploadType("Update")}
                          />
                          <span>Update</span>
                        </label>
                      </div>
                    </Col>

                    <Col lg="4" md="6" sm="12">
                      <FormGroup>
                        <Label>File *</Label>
                        <Input
                          type="file"
                          required
                          onChange={(e) =>
                            setBulkFile(e.target.files?.[0] || null)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end">
                    <Button color="primary" type="submit">
                      Import
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col sm="12">
            <Card className="ap-card">
              <CardBody>
                <Form onSubmit={onSubmit}>
                  <Row>
                    <Col lg="12" className="mb-2">
                      <div className="ap-fy-note">
                        Opening Financial Year will be saved with the selected
                        FY. Existing backend fields Opening_Stock and
                        openingRate are also sent for backward compatibility.
                      </div>
                    </Col>

                    {/* Warehouse */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Warehouse *</Label>
                      <span
                        className="ap-inline-btn"
                        onClick={() => setShowWH(true)}
                      >
                        <IoIosAdd /> Add
                      </span>
                      <Input
                        type="select"
                        value={prod.warehouse}
                        onChange={(e) => onProd("warehouse", e.target.value)}
                        style={{
                          borderColor: errors.warehouse ? "red" : "#ced4da",
                        }}
                        required
                      >
                        <option value="">-- Select Warehouse --</option>
                        {warehouses.map((w) => (
                          <option key={w?._id} value={w?._id}>
                            {w?.warehouseName}
                          </option>
                        ))}
                      </Input>
                      {errors.warehouse && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.warehouse}
                        </div>
                      )}
                    </Col>

                    {/* Category */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Category *</Label>
                      <span
                        className="ap-inline-btn"
                        onClick={() => setShowCat(true)}
                      >
                        <IoIosAdd /> Add
                      </span>
                      <Input
                        type="select"
                        value={prod.category}
                        onChange={(e) => onCategorySelect(e.target.value)}
                        style={{
                          borderColor: errors.category ? "red" : "#ced4da",
                        }}
                        required
                      >
                        <option value="">-- Select Category --</option>
                        {categories.map((c) => (
                          <option key={c?._id} value={c?.name}>
                            {c?.name}
                          </option>
                        ))}
                      </Input>
                      {errors.category && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.category}
                        </div>
                      )}
                    </Col>

                    {/* SubCategory */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>SubCategory</Label>
                      <span
                        className="ap-inline-btn"
                        onClick={() => setShowSub(true)}
                      >
                        <IoIosAdd /> Add
                      </span>
                      <Input
                        type="select"
                        value={prod.SubCategory}
                        onChange={(e) => onProd("SubCategory", e.target.value)}
                      >
                        <option value="">-- Select SubCategory --</option>
                        {subcats.map((s) => (
                          <option key={s?._id} value={s?.name}>
                            {s?.name}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    {/* Product Section */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Product Section</Label>
                      <Input
                        type="select"
                        value={prod.section}
                        onChange={(e) => onProd("section", e.target.value)}
                      >
                        <option value="">-- Select Section --</option>
                        {sectionOptions.map((sec) => (
                          <option key={sec?._id} value={sec?._id}>
                            {sec?.name}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    {/* GST type */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>GST Type *</Label>
                      <Input
                        type="select"
                        value={String(prod.purchaseStatus)}
                        onChange={(e) =>
                          onProd("purchaseStatus", e.target.value)
                        }
                        required
                      >
                        <option value="">-- Select IGST Type --</option>
                        <option value="false">CGST/SGST</option>
                        <option value="true">IGST</option>
                      </Input>
                    </Col>

                    {/* Product Name */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Product Name *</Label>
                      <Input
                        value={prod.Product_Title}
                        onChange={(e) =>
                          onProd("Product_Title", e.target.value.toUpperCase())
                        }
                        placeholder="Product title"
                        style={{
                          borderColor: errors.Product_Title ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.Product_Title && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.Product_Title}
                        </div>
                      )}
                    </Col>

                    {/* HSN */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>HSN *</Label>
                      <Input
                        value={prod.HSN_Code}
                        onChange={(e) => onProd("HSN_Code", e.target.value)}
                        placeholder="HSN Code"
                        style={{
                          borderColor: errors.HSN_Code ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.HSN_Code && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.HSN_Code}
                        </div>
                      )}
                    </Col>

                    {/* GST */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>GST % *</Label>
                      <Input
                        type="number"
                        value={prod.GSTRate}
                        onChange={(e) => onProd("GSTRate", e.target.value)}
                        placeholder="GST percentage"
                        style={{
                          borderColor: errors.GSTRate ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.GSTRate && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.GSTRate}
                        </div>
                      )}
                    </Col>

                    {/* Min stock */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Min Stock *</Label>
                      <Input
                        type="number"
                        value={prod.MIN_stockalert}
                        onChange={(e) =>
                          onProd("MIN_stockalert", e.target.value)
                        }
                        placeholder="Minimum stock"
                        style={{
                          borderColor: errors.MIN_stockalert
                            ? "red"
                            : "#ced4da",
                        }}
                        required
                      />
                      {errors.MIN_stockalert && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.MIN_stockalert}
                        </div>
                      )}
                    </Col>

                    {/* Primary Unit */}
                    {/* Primary Unit */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Primary Unit *</Label>
                      <Input
                        type="select"
                        value={prod.primaryUnit || ""}
                        onChange={(e) => onProd("primaryUnit", e.target.value)}
                        style={{
                          borderColor: errors.primaryUnit ? "red" : "#ced4da",
                        }}
                        required
                      >
                        <option value="">-- Select Unit --</option>
                        {units.map((u) => (
                          <option
                            key={u?.unitId || u?.unitName}
                            value={u?.unitName}
                          >
                            {u?.unitName}
                          </option>
                        ))}
                      </Input>
                      {errors.primaryUnit && (
                        <div
                          className="ap-small ep-small"
                          style={{ color: "red" }}
                        >
                          {errors.primaryUnit}
                        </div>
                      )}
                    </Col>

                    {/* Secondary Unit */}
                    {/* Secondary Unit */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Secondary Unit</Label>
                      <Input
                        type="select"
                        value={prod.secondaryUnit || ""}
                        onChange={(e) =>
                          onProd("secondaryUnit", e.target.value)
                        }
                      >
                        <option value="">-- Select Unit --</option>
                        {units.map((u) => (
                          <option
                            key={u?.unitId || u?.unitName}
                            value={u?.unitName}
                          >
                            {u?.unitName}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    {prod.secondaryUnit ? (
                      <Col lg="3" md="4" sm="6" className="mb-2">
                        <Label>Secondary Qty *</Label>
                        <Input
                          type="number"
                          value={prod.secondarySize}
                          onChange={(e) =>
                            onProd("secondarySize", e.target.value)
                          }
                          placeholder="Secondary quantity"
                          style={{
                            borderColor: errors.secondarySize
                              ? "red"
                              : "#ced4da",
                          }}
                          required
                        />
                        {errors.secondarySize && (
                          <div className="ap-small" style={{ color: "red" }}>
                            {errors.secondarySize}
                          </div>
                        )}
                      </Col>
                    ) : null}

                    {/* Financial Year */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Opening Financial Year *</Label>
                      <Input
                        type="select"
                        value={prod.financialYear}
                        onChange={(e) =>
                          onProd(
                            "financialYear",
                            normalizeFinancialYear(e.target.value),
                          )
                        }
                        style={{
                          borderColor: errors.financialYear ? "red" : "#ced4da",
                        }}
                        required
                      >
                        {fyOptions.map((fy) => (
                          <option key={fy} value={fy}>
                            {fy}
                          </option>
                        ))}
                      </Input>
                      {errors.financialYear && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.financialYear}
                        </div>
                      )}
                    </Col>

                    {/* Opening Stock */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Opening Stock ({prod.financialYear}) *</Label>
                      <Input
                        type="number"
                        value={prod.Opening_Stock}
                        onChange={(e) =>
                          onProd("Opening_Stock", e.target.value)
                        }
                        placeholder="Opening stock"
                        style={{
                          borderColor: errors.Opening_Stock ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.Opening_Stock && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.Opening_Stock}
                        </div>
                      )}
                    </Col>

                    {/* Opening Rate */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Opening Rate ({prod.financialYear}) *</Label>
                      <Input
                        type="number"
                        value={prod.openingRate}
                        onChange={(e) => onProd("openingRate", e.target.value)}
                        placeholder="Opening rate"
                        style={{
                          borderColor: errors.openingRate ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.openingRate && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.openingRate}
                        </div>
                      )}
                    </Col>

                    {/* Opening Total Preview */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Opening Total</Label>
                      <Input
                        value={(
                          num0(prod.Opening_Stock) * num0(prod.openingRate)
                        ).toFixed(2)}
                        disabled
                        style={{ background: "#f8fafc", fontWeight: 800 }}
                      />
                    </Col>

                    {/* Purchase Rate */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Purchase Rate *</Label>
                      <Input
                        type="number"
                        value={prod.Purchase_Rate}
                        onChange={(e) =>
                          onProd("Purchase_Rate", e.target.value)
                        }
                        placeholder="Purchase rate"
                        style={{
                          borderColor: errors.Purchase_Rate ? "red" : "#ced4da",
                        }}
                        required
                      />
                      {errors.Purchase_Rate && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.Purchase_Rate}
                        </div>
                      )}
                    </Col>

                    {/* Images */}
                    <Col lg="12" className="mb-2">
                      <Label>Product Images</Label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          flexWrap: "wrap",
                        }}
                      >
                        <label
                          style={{
                            display: "inline-grid",
                            placeItems: "center",
                            width: 26,
                            height: 26,
                            borderRadius: 14,
                            cursor: "pointer",
                            background: "#e2e8f0",
                          }}
                          title="Choose files"
                        >
                          <FaUpload />
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={(e) => addImages(e.target.files)}
                          />
                        </label>

                        <span className="ap-small">
                          You can select multiple images.
                        </span>
                      </div>

                      <Row className="mt-2">
                        {imgPrev.map((src, i) => (
                          <Col
                            key={i}
                            lg="2"
                            md="3"
                            sm="4"
                            xs="6"
                            className="mb-2"
                            style={{ position: "relative" }}
                          >
                            <span
                              className="ap-del"
                              onClick={() => removeImage(i)}
                            >
                              <MdCancel size={22} color="red" />
                            </span>
                            <img
                              className="ap-img"
                              src={src}
                              alt={`img-${i}`}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Col>

                    {/* Status */}
                    <Col lg="3" md="4" sm="6" className="mb-2">
                      <Label>Status *</Label>
                      <div className="d-flex" style={{ gap: 16 }}>
                        <label
                          className="m-0 d-flex align-items-center"
                          style={{ gap: 6 }}
                        >
                          <Input
                            type="radio"
                            name="status"
                            checked={prod.status === "Active"}
                            onChange={() => onProd("status", "Active")}
                          />
                          <span>Active</span>
                        </label>

                        <label
                          className="m-0 d-flex align-items-center"
                          style={{ gap: 6 }}
                        >
                          <Input
                            type="radio"
                            name="status"
                            checked={prod.status === "Deactive"}
                            onChange={() => onProd("status", "Deactive")}
                          />
                          <span>Deactive</span>
                        </label>
                      </div>

                      {errors.status && (
                        <div className="ap-small" style={{ color: "red" }}>
                          {errors.status}
                        </div>
                      )}
                    </Col>
                  </Row>

                  <div
                    className="d-flex justify-content-end"
                    style={{ gap: 8 }}
                  >
                    <Button
                      color="secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>

                    <Button color="primary" type="submit" disabled={creating}>
                      {creating ? "Saving..." : "Submit"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      {/* Modal: Add Warehouse */}
      <Modal isOpen={showWH} toggle={() => setShowWH(false)} backdrop="static">
        <ModalHeader toggle={() => setShowWH(false)}>
          Create Warehouse
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={onCreateWH}>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Warehouse Name</Label>
                  <Input
                    value={whForm.warehouseName}
                    onChange={(e) =>
                      setWhForm((p) => ({
                        ...p,
                        warehouseName: e.target.value,
                      }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Address</Label>
                  <Input
                    value={whForm.warehouseAddress}
                    onChange={(e) =>
                      setWhForm((p) => ({
                        ...p,
                        warehouseAddress: e.target.value,
                      }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Mobile</Label>
                  <Input
                    type="number"
                    value={whForm.warehouseMobile}
                    onChange={(e) =>
                      setWhForm((p) => ({
                        ...p,
                        warehouseMobile: e.target.value,
                      }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Landline</Label>
                  <Input
                    type="number"
                    value={whForm.landlineNumber}
                    onChange={(e) =>
                      setWhForm((p) => ({
                        ...p,
                        landlineNumber: e.target.value,
                      }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="12" className="mb-2">
                <Label>Status</Label>
                <div className="d-flex gap-3">
                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="whStatus"
                      checked={whForm.status === "Active"}
                      onChange={() =>
                        setWhForm((p) => ({ ...p, status: "Active" }))
                      }
                    />
                    <span>Active</span>
                  </label>

                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="whStatus"
                      checked={whForm.status === "Deactive"}
                      onChange={() =>
                        setWhForm((p) => ({ ...p, status: "Deactive" }))
                      }
                    />
                    <span>Deactive</span>
                  </label>
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
              <Button
                color="secondary"
                type="button"
                onClick={() => setShowWH(false)}
              >
                Cancel
              </Button>

              <Button color="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      {/* Modal: Add Category */}
      <Modal
        isOpen={showCat}
        toggle={() => setShowCat(false)}
        backdrop="static"
      >
        <ModalHeader toggle={() => setShowCat(false)}>
          Create Category
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={onCreateCat}>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Name</Label>
                  <Input
                    value={catForm.name}
                    onChange={(e) =>
                      setCatForm((p) => ({ ...p, name: e.target.value }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    value={catForm.description}
                    onChange={(e) =>
                      setCatForm((p) => ({ ...p, description: e.target.value }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="12">
                <Label>Status</Label>
                <div className="d-flex gap-3">
                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="catStatus"
                      checked={catForm.status === "Active"}
                      onChange={() =>
                        setCatForm((p) => ({ ...p, status: "Active" }))
                      }
                    />
                    <span>Active</span>
                  </label>

                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="catStatus"
                      checked={catForm.status === "Deactive"}
                      onChange={() =>
                        setCatForm((p) => ({ ...p, status: "Deactive" }))
                      }
                    />
                    <span>Deactive</span>
                  </label>
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
              <Button
                color="secondary"
                type="button"
                onClick={() => setShowCat(false)}
              >
                Cancel
              </Button>

              <Button color="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      {/* Modal: Add Subcategory */}
      <Modal
        isOpen={showSub}
        toggle={() => setShowSub(false)}
        backdrop="static"
      >
        <ModalHeader toggle={() => setShowSub(false)}>
          Create Subcategory
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={onCreateSub}>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Parent Category *</Label>
                  <Input
                    type="select"
                    value={subForm.categoryId}
                    onChange={(e) =>
                      setSubForm((p) => ({ ...p, categoryId: e.target.value }))
                    }
                    required
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((c) => (
                      <option key={c?._id} value={c?._id}>
                        {c?.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Subcategory Name *</Label>
                  <Input
                    value={subForm.name}
                    onChange={(e) =>
                      setSubForm((p) => ({ ...p, name: e.target.value }))
                    }
                    required
                  />
                </FormGroup>
              </Col>

              <Col md="12">
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    value={subForm.description}
                    onChange={(e) =>
                      setSubForm((p) => ({ ...p, description: e.target.value }))
                    }
                  />
                </FormGroup>
              </Col>

              <Col md="12">
                <Label>Status</Label>
                <div className="d-flex gap-3">
                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="subStatus"
                      checked={subForm.status === "Active"}
                      onChange={() =>
                        setSubForm((p) => ({ ...p, status: "Active" }))
                      }
                    />
                    <span>Active</span>
                  </label>

                  <label className="m-0 d-flex align-items-center gap-1">
                    <Input
                      type="radio"
                      name="subStatus"
                      checked={subForm.status === "Deactive"}
                      onChange={() =>
                        setSubForm((p) => ({ ...p, status: "Deactive" }))
                      }
                    />
                    <span>Deactive</span>
                  </label>
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
              <Button
                color="secondary"
                type="button"
                onClick={() => setShowSub(false)}
              >
                Cancel
              </Button>

              <Button color="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}
